import { WishlistItem } from './wishlistItem';
export class PagedWishlistDetails {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
    items: WishlistItem[] = [];
}
